import { navbarRouteImage } from "../assets/routeImage";

export type thirdMenuProps = {
    subThirdMenuId: number;
    subThirdMenuName: string;
    path: string;
    code: string;
}

export type subMenuProps = {
    subMenuId: number;
    subMenuName: string;
    path: string;
    subThirdMenu: thirdMenuProps[]
    code?: string;
}

export type menuProps = {
    id: number
    menuName: string
    icon: string;
    path: string;
    subMenu: subMenuProps[];
    code?: string
}



export const Menu: menuProps[] = [
    {
        id: 1,
        menuName: "สถิติข้อมูล",
        icon: navbarRouteImage.statisticsIcon,
        path: "/auth/statistics",
        code: "Statistics.Open",
        subMenu: [],
    },
    {
        id: 2,
        menuName: "ข้อมูลโครงการ",
        icon: navbarRouteImage.projectInformation,
        path: "/auth/project-information",
        code: "ProjectInformation.Open",
        subMenu: []
    },
    {
        id: 3,
        menuName: "ติดตามสถานะโครงการ",
        icon: navbarRouteImage.projectStatus,
        path: "/auth/project-status",
        code: "ProjectStatus.Open",
        subMenu: []
    },
    {
        id: 4,
        menuName: "รายงาน",
        icon: navbarRouteImage.report,
        path: "/auth/report",
        code: "Report.Open",
        subMenu: [
            {
                subMenuId: 55,
                subMenuName: "บัญชีสรุปผลการติดตาม",
                path: "/auth/report/tracking-summary-account",
                subThirdMenu: []
            },
            {
                subMenuId: 5,
                subMenuName: "บ้ญชีครุภัณฑ์",
                path: "/auth/report/equipment-account",
                subThirdMenu: []
            },
            {
                subMenuId: 6,
                subMenuName: "ผลสัมฤทธิ์การดำเนินงาน",
                path: "/auth/report/operational-achievements",
                subThirdMenu: []
            },
            {
                subMenuId: 7,
                subMenuName: "ผลการใช้จ่ายงบประมาณ",
                path: "/auth/report/budget-spending",
                subThirdMenu: []
            },
            {
                subMenuId: 8,
                subMenuName: "ความสำเร็จของโครงการ",
                path: "/auth/report/project-success",
                subThirdMenu: []
            },
            {
                subMenuId: 9,
                subMenuName: "ความคืบหน้าโครงการ",
                path: "/auth/report/project-progress",
                subThirdMenu: []
            },
        ]
    },
    {
        id: 15,
        menuName: "สถิติการใช้งาน",
        icon: navbarRouteImage.usageStatistics,
        path: "/auth/usage-statistics",
        code: "UsageStatistics.Open",
        subMenu: []
    },
    {
        id: 16,
        menuName: "ตั้งค่า",
        icon: navbarRouteImage.setting,
        path: "/auth/setting",
        code: "Setting.Open",
        subMenu: [
            {
                subMenuId: 17,
                subMenuName: "ปีงบประมาณ",
                path: "/auth/setting/fiscal-year",
                code: "FiscalYear.Open",
                subThirdMenu: [
                    {
                        subThirdMenuId: 18,
                        subThirdMenuName: "ยุทธศาสตร์/กลยุทธ์",
                        path: "strategic",
                        code: "Strategic.Open",
                    },
                    {
                        subThirdMenuId: 19,
                        subThirdMenuName: "ประเภทภารกิจ",
                        path: "mission-type",
                        code: "FiscalYear.Open",
                    },
                    {
                        subThirdMenuId: 20,
                        subThirdMenuName: "ผลสัมฤทธิ์ความคืบหน้าโครงการ",
                        path: "project-progress",
                        code: "FiscalYear.Open",
                    },
                    {
                        subThirdMenuId: 21,
                        subThirdMenuName: "การแจ้งเตือนหน้าหลัก",
                        path: "notification",
                        code: "FiscalYear.Open",
                    },
                    {
                        subThirdMenuId: 22,
                        subThirdMenuName: "ประเภทโครงการ",
                        path: "project-type",
                        code: "FiscalYear.Open",
                    },
                    // {
                    //     subThirdMenuId: 30,
                    //     subThirdMenuName: "ขั้นตอนดำเนินโครงการ",
                    //     path: "operation",
                    //     code: "FiscalYear.Open",
                    // },

                ]
            },
            {
                subMenuId: 23,
                subMenuName: "แผนงาน",
                path: "/auth/setting/plan",
                subThirdMenu: [],
                code: "Plan.Open",
            },
            {
                subMenuId: 24,
                subMenuName: "แหล่งที่มางบประมาณ",
                path: "/auth/setting/budget-source",
                subThirdMenu: [],
                code: "BudgetSource.Open",
            },
            {
                subMenuId: 25,
                subMenuName: "หน่วยงาน",
                path: "/auth/setting/agency",
                subThirdMenu: [],
                code: "Agency.Open",
            },
            {
                subMenuId: 26,
                subMenuName: "จัดการผู้ใช้งาน",
                path: "/auth/setting/system-users",
                subThirdMenu: [],
                code: "SystemUsers.Open"
            },
            {
                subMenuId: 27,
                subMenuName: "จัดการบทบาท",
                path: "/auth/setting/permission",
                subThirdMenu: [],
                code: "Permission.Open"

            },
            {
                subMenuId: 29,
                subMenuName: "ปรับแต่ง",
                path: "/auth/setting/customize",
                code: "Customize.Open",
                subThirdMenu: []
            },
        ]
    },
]